module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_1@2x-795cb6623d03e206155ac16eccbe8b6e.jpg";